import { motion } from "framer-motion";
import * as Icons from "lucide-react";
import { Check } from "lucide-react";
import { DIFFERENCE_BULLETS, HELP_CARDS, IMAGES } from "@/data/site";

export const About = () => {
  return (
    <section id="about" data-testid="about-section" className="bg-[#0A0A0A] py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="relative rounded-sm overflow-hidden border border-white/10"
          >
            <img src={IMAGES.handshake} alt="Personal car buying help" className="w-full h-[440px] object-cover" />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" />
          </motion.div>

          <div>
            <p className="text-xs font-bold tracking-[0.25em] uppercase text-[#C8102E]">The Cars With Malcolm Difference</p>
            <h2 className="mt-4 font-heading text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight uppercase text-white leading-[0.95]">
              More than a sale. <span className="text-[#C8102E]">It's personal.</span>
            </h2>
            <p className="mt-6 text-base lg:text-lg text-gray-400 leading-relaxed">
              Malcolm believes getting a vehicle should feel clear, honest, and manageable. His role is to listen, understand your situation, answer your questions, and help you take the next step with confidence.
            </p>
            <ul className="mt-8 space-y-3">
              {DIFFERENCE_BULLETS.map((b) => (
                <li key={b} className="flex items-center gap-3 text-gray-200">
                  <span className="flex h-6 w-6 items-center justify-center rounded-full bg-[#C8102E]/20 border border-[#C8102E]/40">
                    <Check size={14} className="text-[#C8102E]" />
                  </span>
                  <span className="text-sm lg:text-base">{b}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div id="services" data-testid="services-section" className="mt-24 scroll-mt-24">
          <p className="text-xs font-bold tracking-[0.25em] uppercase text-[#C8102E]">Services</p>
          <h3 className="mt-4 font-heading text-3xl sm:text-4xl font-bold tracking-tight uppercase text-white">How Malcolm helps</h3>
          <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {HELP_CARDS.map((c, i) => {
              const Icon = Icons[c.icon] || Icons.Car;
              return (
                <motion.div
                  key={c.title}
                  initial={{ opacity: 0, y: 24 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: i * 0.1, duration: 0.5 }}
                  data-testid={`help-card-${i}`}
                  className="group bg-[#121212] border border-white/10 rounded-sm p-7 hover:border-[#C8102E]/50 transition-colors"
                >
                  <span className="flex h-12 w-12 items-center justify-center rounded-sm bg-[#C8102E]/15 border border-[#C8102E]/30 group-hover:bg-[#C8102E] transition-colors">
                    <Icon size={22} className="text-[#C8102E] group-hover:text-white transition-colors" />
                  </span>
                  <h4 className="mt-5 font-heading text-lg font-bold tracking-tight uppercase text-white">{c.title}</h4>
                  <p className="mt-2 text-sm text-gray-400 leading-relaxed">{c.copy}</p>
                </motion.div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};
